export const stateOptions = [
  { label: "Aguascalientes", value: "AGS", code: 100 },
  { label: "Baja California", value: "BC", code: 132 },
  { label: "Baja California Sur", value: "BCS", code: 102 },
  { label: "Campeche", value: "CAM", code: 138 },
  { label: "CDMX", value: "CDM", code: 115 },
  { label: "Chihuahua", value: "CHI", code: 104 },
  { label: "Chiapas", value: "CHS", code: 105 },
  { label: "Coahuila", value: "COA", code: 106 },
  { label: "Colima", value: "COL", code: 107 },
  { label: "Durango", value: "DUR", code: 108 },
  { label: "Guerrero", value: "GRO", code: 109 },
  { label: "Guanajuato", value: "GTO", code: 110 },
  { label: "Hidalgo", value: "HID", code: 111 },
  { label: "Jalisco", value: "JAL", code: 112 },
  { label: "Michoacan", value: "MCH", code: 113 },
  { label: "Estado de México", value: "MEX", code: 114 },
  { label: "Morelos", value: "MOR", code: 116 },
  { label: "Nayarit", value: "NAY", code: 117 },
  { label: "Nuevo León", value: "NL", code: 118 },
  { label: "Oaxaca", value: "OAX", code: 119 },
  { label: "Puebla", value: "PUE", code: 120 },
  { label: "Quintana Roo", value: "QR", code: 121 },
  { label: "Queretaro", value: "QUE", code: 122 },
  { label: "Sinaloa", value: "SIN", code: 123 },
  { label: "San Luis Potosi", value: "SLP", code: 124 },
  { label: "Sonora", value: "SON", code: 125 },
  { label: "Tabasco", value: "TAB", code: 126 },
  { label: "Tamaulipas", value: "TAM", code: 127 },
  { label: "Tlaxcala", value: "TLA", code: 128 },
  { label: "Veracruz", value: "VER", code: 129 },
  { label: "Yucatan", value: "YUC", code: 130 },
  { label: "Zacatecas", value: "ZAC", code: 131 },
];

export interface LoginBrand {
  name: string;
  icon: string;
}

export const loginBrands: Record<string, LoginBrand> = {
  GOOGLE: { name: "Google", icon: "google-icon.svg" },
  // APPLE: { name: "Apple", icon: "apple-logo.svg" },
  MICROSOFT: { name: "Microsoft", icon: "micorsoftLogo.png" },
  // FACEBOOK: { name: "Facebook", icon: "facebook-icon.svg" },
};

export const passwordRules = {
  required: "La contraseña es requerida",
  minLength: {
    value: 8,
    message: "Mínimo 8 caracteres",
  },
  maxLength: {
    value: 100,
    message: "Máximo 100 caracteres",
  },
  pattern: {
    value:
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#.\-_])[A-Za-z\d@$!%*?&#.\-_]{8,100}$/,
    message: "Debe tener mayúscula, minúscula, dígito, especial y sin espacios",
  },
  validate: (value: string) =>
    !/\s/.test(value) || "No debe contener espacios en blanco",
};

export const regimenOptions = [
  { label: "G01 - Adquisición de mercancías", value: "G01" },
  { label: "G02 - Devoluciones, descuentos o bonificaciones", value: "G02" },
  { label: "G03 - Gastos en general", value: "G03" },
  { label: "I01 - Construcciones", value: "I01" },
  {
    label: "I02 - Mobiliario y equipo de oficina por inversiones",
    value: "I02",
  },
  { label: "I03 - Equipo de transporte", value: "I03" },
  { label: "I04 - Equipo de computo y accesorios", value: "I04" },
  {
    label: "I05 - Dados, troqueles, moldes, matrices y herramental",
    value: "I05",
  },
  { label: "I06 - Comunicaciones telefónicas", value: "I06" },
  { label: "I07 - Comunicaciones satelitales", value: "I07" },
  { label: "I08 - Otra maquinaria y equipo", value: "I08" },
  {
    label: "D01 - Honorarios médicos, dentales y gastos hospitalarios",
    value: "D01",
  },
  {
    label: "D02 - Gastos médicos por incapacidad o discapacidad",
    value: "D02",
  },
  { label: "D03 - Gastos funerales", value: "D03" },
  { label: "D04 - Donativos", value: "D04" },
  {
    label:
      "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)",
    value: "D05",
  },
  { label: "D06 - Aportaciones voluntarias al SAR", value: "D06" },
  { label: "D07 - Primas por seguros de gastos médicos", value: "D07" },
  {
    label: "D08 - Gastos de transportación escolar obligatoria",
    value: "D08",
  },
  {
    label:
      "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones",
    value: "D09",
  },
  {
    label: "D10 - Pagos por servicios educativos (colegiaturas)",
    value: "D10",
  },
  { label: "S01 - Sin efectos fiscales", value: "S01" },
  { label: "CP01 - Pagos", value: "CP01" },
  { label: "CN01 - Nómina", value: "CN01" },
];

export const statusOptions = {
  APPROVED_NOT_CREATED_SAP: {
    label: "Aprobada - No creada en SAP",
    description:
      "Aprobada por un admin, pero el Business Partner aún no ha sido creado en SAP (falló o está pendiente).",
  },
  PENDING: {
    label: "Pendiente",
    description: "La solicitud está pendiente de aprobación.",
  },
  REJECTED: {
    label: "Rechazada",
    description: "La solicitud ha sido rechazada.",
  },
  SAP_LINKED: {
    label: "Aprobada",
    description:
      "Business Partner creado y cuenta comercial vinculada con SAP. Estado final exitoso.",
  },
  APPROVED_CREATED_SAP: {
    label: "Aprobada - Creada en SAP",
    description:
      " Business Partner ya creado en SAP, pero la cuenta comercial todavía no ha sido vinculada.",
  },
};

export const oficess = [
  { label: "Ciudad de México", value: 3 },
  { label: "Guadalajara", value: 1 },
  { label: "Monterrey", value: 2 },
  { label: "León", value: 4 },
  { label: "Tijuana", value: 6 },
];

export const regimenFiscalOptions = [
  { value: "601", label: "601 – General de Ley Personas Morales" },
  {
    value: "612",
    label: "612 – Personas Físicas con Actividades Empresariales",
  },
  { value: "626", label: "626 – Régimen Simplificado de Confianza" },
  { label: " 606 - Arrendamiento", value: "606" },
  {
    label: " 605 - Sueldos y Salarios e Ingresos Asimilados a Salarios",
    value: "605",
  },
];

// ─── Order Status Labels ────────────────────────────────────────────────────

export const ORDER_STATUS_LABELS: Record<string, string> = {
  DRAFT: "Carrito en edición",
  QUOTATION_PENDING: "Esperando confirmación de pago",
  SALES_ORDER_PENDING: "Pago confirmado",
  ORDER_CONFIRMED: "Pago confirmado",
  DELIVERY_IN_PROGRESS: "Preparando su envio",
  PARTIALLY_DELIVERED: "Algunos productos han sido enviados",
  DELIVERED_FULL: "Todos sus productos han sido enviados",
  DELIVERED_CONFIRM: "Productos entregados",
  QUOTATION_EXPIRED: "Pedido expirado",
  CANCELLED: "Cancelado",
};

export const getStatusLabel = (statusCode?: string) => {
  return (statusCode && ORDER_STATUS_LABELS[statusCode]) || statusCode || "";
};

export const PAYMENT_STATUS_LABELS: Record<string, string> = {
  NONE: "Sin confirmar",
  PENDING: "Pendiente",
  IN_PROGRESS: "En proceso",
  COMPLETED: "Completado",
  CANCELLED: "Cancelado",
  FAILED: "Fallido",
  CONFIRMED: "Confirmado",
  APPROVED: "Aprobado",
  REJECTED: "Rechazado",
  PAID: "Pagado",
  UNPAID: "No pagado",
  PENDING_LINK: "Pendiente de enlace",
  LINK_CREATED: "Enlace creado",
  PENDING_TRANSFER: "Pendiente transferencia",
  PENDING_CREDIT: "Pendiente crédito",
  EXPIRED: "Expirado",
  SUCCEEDED: "Aprobado",
  SALES_ORDER_PENDING: "En preparación",
};

export const getPaymentStatusLabel = (status?: string) => {
  return (status && PAYMENT_STATUS_LABELS[status]) || status || "";
};

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  NONE: "Ninguno",
  BANK_TRANSFER: "Transferencia Bancaria",
  CREDIT_CARD: "Tarjeta de Crédito",
  CASH: "Efectivo",
  ADISES_CREDIT: "Crédito",
  CREDIT: "Crédito",
  SANTANDER: "Tarjeta bancaria",
  ADISES_CREDIT_MXN: "Crédito (MXN)",
};

export const getPaymentMethodLabel = (method?: string) => {
  return (method && PAYMENT_METHOD_LABELS[method]) || method || "";
};

/**
 * Métodos de pago que representan crédito ADISES: no pasan por un
 * procesador de tarjeta/banco, por lo que nunca tienen un número de
 * transacción asociado.
 */
const CREDIT_PAYMENT_METHODS = ["CREDIT", "ADISES_CREDIT", "ADISES_CREDIT_MXN"];

export const isCreditPaymentMethod = (method?: string | null) =>
  Boolean(method && CREDIT_PAYMENT_METHODS.includes(method));

/**
 * El backend a veces devuelve "N/A" para direcciones sin un nombre de
 * destinatario real capturado. Lo tratamos como si estuviera vacío para
 * que nunca se muestre ni se precargue como si fuera un valor válido.
 */
export const sanitizeRecipientName = (value: unknown): string => {
  const str = String(value ?? "").trim();
  return /^n\/?a$/i.test(str) ? "" : str;
};

// ─── Select Options ─────────────────────────────────────────────────────────

export const ORDER_STATUS_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "QUOTATION_PENDING", label: "Esperando confirmación de pago" },
  { value: "SALES_ORDER_PENDING", label: "Orden de venta pendiente" },
  { value: "ORDER_CONFIRMED", label: "Orden confirmada" },
  { value: "DELIVERY_IN_PROGRESS", label: "Entrega en progreso" },
  { value: "PARTIALLY_DELIVERED", label: "Entrega parcial" },
  { value: "DELIVERED_FULL", label: "Entregado (SAP)" },
  { value: "DELIVERED_CONFIRM", label: "Entrega física confirmada" },
  { value: "QUOTATION_EXPIRED", label: "Cotización expirada" },
  { value: "CANCELLED", label: "Cancelado" },
];

export const STATUS_OPTIONS = ORDER_STATUS_OPTIONS;

// PaymentOrderStatus (backend) solo tiene estos 3 valores - un valor fuera
// de este enum en el query param dispara 400 (MethodArgumentTypeMismatchException).
export const PAYMENT_STATUS_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "PENDING", label: "Pendiente" },
  { value: "APPROVED", label: "Aprobado" },
  { value: "REJECTED", label: "Rechazado" },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "BANK_TRANSFER", label: "Transferencia bancaria" },
  { value: "CREDIT", label: "Crédito" },
  { value: "SANTANDER", label: "Tarjeta bancaria" },
];

export const SHIPPING_STATUS_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "EN_PREPARACION", label: "En preparación" },
  { value: "PROCESADO", label: "Procesado" },
  { value: "EN_TRANSITO", label: "En tránsito" },
  { value: "ENTREGADO", label: "Entregado" },
];

export const ISSUE_PROCESS_TYPE_LABELS: Record<string, string> = {
  SAP_QUOTATION_CREATION: "Creación de cotización",
  SAP_SALES_ORDER_CREATION: "Creación de orden de venta ",
  SAP_CREDIT_VALIDATION: "Validación de crédito SAP",
  SAP_ATTACHMENT: "Adjunto de comprobantes",
  SAP_CART_VALIDATION: "Validación de carrito ",
  PAYMENT_CONFIRMATION: "Confirmación de pago",
  ORDER_CANCELLATION: "Cancelación de pedido",
  QUOTATION_REACTIVATION: "Reactivación de cotización",
};

export const ISSUE_PROCESS_TYPE_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "SAP_QUOTATION_CREATION", label: "Creación de cotización" },
  {
    value: "SAP_SALES_ORDER_CREATION",
    label: "Creación de orden de venta ",
  },
  { value: "SAP_CREDIT_VALIDATION", label: "Validación de crédito SAP" },
  { value: "SAP_ATTACHMENT", label: "Adjunto de comprobantes" },
  {
    value: "SAP_CART_VALIDATION",
    label: "Validación de carrito ",
  },
  { value: "PAYMENT_CONFIRMATION", label: "Confirmación de pago" },
  { value: "ORDER_CANCELLATION", label: "Cancelación de pedido" },
  { value: "QUOTATION_REACTIVATION", label: "Reactivación de cotización" },
];

export const ISSUE_OPERATION_TYPE_LABELS: Record<string, string> = {
  ATTEMPT_FAILED: "Intento fallido",
  MAX_ATTEMPTS_EXHAUSTED: "Máximo de intentos agotado",
  CREDIT_INSUFFICIENT: "Crédito insuficiente",
  UNEXPECTED_STATE: "Estado inesperado",
};

export const ISSUE_OPERATION_TYPE_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "ATTEMPT_FAILED", label: "Intento fallido" },
  { value: "MAX_ATTEMPTS_EXHAUSTED", label: "Máximo de intentos agotado" },
  { value: "CREDIT_INSUFFICIENT", label: "Crédito insuficiente" },
  { value: "UNEXPECTED_STATE", label: "Estado inesperado" },
];

export const ISSUE_SOURCE_LABELS: Record<string, string> = {
  CHECKOUT_FLOW: "Flujo de checkout",
  BANK_TRANSFER_APPROVAL: "Aprobación de transferencia",
  KAFKA_PAYMENT_CONFIRMED: "Pago confirmado",
  SCHEDULER: "Scheduler de reintentos",
  ADMIN_RETRY: "Reintento manual ",
  KAFKA_SAP_SYNC: "Sincronización SAP",
  REACTIVATION_FLOW: "Flujo de reactivación",
  CREDIT_APPROVAL: "Aprobación de crédito",
};

export const ISSUE_SOURCE_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "CHECKOUT_FLOW", label: "Flujo de checkout" },
  { value: "BANK_TRANSFER_APPROVAL", label: "Aprobación de transferencia" },
  { value: "KAFKA_PAYMENT_CONFIRMED", label: "Pago confirmado" },
  { value: "SCHEDULER", label: "Scheduler de reintentos" },
  { value: "ADMIN_RETRY", label: "Reintento manual " },
  { value: "KAFKA_SAP_SYNC", label: "Sincronización SAP" },
  { value: "REACTIVATION_FLOW", label: "Flujo de reactivación" },
  { value: "CREDIT_APPROVAL", label: "Aprobación de crédito" },
];

export const internalRole = "INTERNAL";
export const supplier = "SUPPLIER";
export const customer = "CUSTOMER";
export const userLinked = "CUSTOMER_SAP";

export const roleOptions = [
  { value: internalRole, label: "Interno" },
  { value: supplier, label: "Proveedor" },
  { value: customer, label: "Cliente" },
  { value: userLinked, label: "Cliente SAP" },
];

export const pricingTypes = {
  PRECIO_LISTA: "Precio de lista",
  PRECIO_INTEGRADOR: "Precio integrador",
  PRECIOS_POR_PERIODO_Y_CANTIDAD_SIN_RANGOS: "Precio de promoción",
  PRECIOS_POR_PERIODO_Y_CANTIDAD_RANGOS: "Precio de promoción",
  PRECIO_LIQUIDACION: "Precio de liquidación",
};

export const CART_TOAST_CONTAINER_ID = "cart";

// Caracteres mínimos para lanzar la búsqueda en el encabezado y en el menú.
export const searchMinChars = 3;
